import React, { useEffect, useState } from 'react';
import { Table, Button, Spinner, Alert } from 'react-bootstrap';
import { ReactIcons } from '../../../icons';
// import { GET_SUVIVALS } from '../../../apollo/unit/Query';
import { covertTimeZone } from '../../../helper';
import { useLazyQuery, useMutation } from '@apollo/client';
// import { DELETED_Promotion } from '../../../apollo/unit/Mutation';
import AnimationLoading from '../../../components/Animationloading';
import FormPromotion from './FormPromotion';
import { GET_PROMOTIONS } from '../../../apollo/shop/Query';
import { UPDATE_PROMOTION } from '../../../apollo/shop/mutation';
import { COLOR_WHITE } from '../../../const';

const Promotions = () => {
    const [onShowModal, setOnShowModal] = useState({
        isOpen: false,
        data: null,
        editMode: false
    });
    const [promotionDatas, setPromotionDatas] = useState([]);
    // const [promotionTotal, setPromotionTotal] = useState(0);
    const [idDeleted, setIdDeleted] = useState(null);

    // apollo client hooks
    const [getPromotionData, { loading: loadingPromotion, data: promotionDatasLoad }] = useLazyQuery(GET_PROMOTIONS, {
        fetchPolicy: "cache-and-network"
    });
    const [updatePromotion, { loading: loadingUpdatePromotion }] = useMutation(UPDATE_PROMOTION);


    // useEffect Hooks
    useEffect(() => {
        // Get shop data from localStorage
        const userData = localStorage.getItem("SHOP_DATA");
        if (userData) {
            const locals = JSON.parse(userData);
            if (locals) {
                fetchPromotionDatas(locals.id);
            }
        }
    }, [])

    useEffect(() => {
        if (promotionDatasLoad) {
            setPromotionDatas(promotionDatasLoad?.getPromotions?.data || []);
        }
    }, [promotionDatasLoad]);


    // Fetch Promotion data based on shop ID
    const fetchPromotionDatas = async (shopId) => {
        if (loadingPromotion) return; // Prevent re-triggering if already loading

        try {
            await getPromotionData({
                variables: {
                    where: {
                        shop: shopId,
                        isDeleted: false,
                        // status: "ACTIVED"
                    }
                }
            });
        } catch (err) {
            console.log("Load Promotion error: ", err);
        }
    }

    const handleCloseModal = () => {
        setOnShowModal({
            isOpen: false,
            data: null,
            editMode: false
        })
        const userData = localStorage.getItem("SHOP_DATA");
        if (userData) {
            const locals = JSON.parse(userData);
            if (locals) {
                fetchPromotionDatas(locals.id);
            }
        }
    }

    // update Promotion
    const handleUpdate = async (_data) => {
        if (loadingUpdatePromotion) return;
        setIdDeleted(_data?.id)
        const userData = localStorage.getItem("SHOP_DATA");
        if (!userData) return;
        const locals = JSON.parse(userData);
        try {
            const res = await updatePromotion({
                variables: {
                    where: {
                        id: _data?.id
                    },
                    data: {
                        status: "ACTIVED",
                        shop: locals?.id
                    },
                }
            });
            if (res) {
                handleCloseModal()
            }
        } catch (error) {
            console.error(error);
        }
    };

    // Check if there are any active promotions
    const hasActivePromotion = promotionDatas.some(promotion => promotion.status === "ACTIVED");

    return (
        <React.Fragment>
            {!onShowModal.isOpen ? <div className="container p-4 bg-white">
                {!hasActivePromotion && <Alert variant="danger" className='w-100 text-center'>
                    <p style={{ fontWeight: 'bold', fontSize: 18, marginTop: 7 }}>ບໍ່ມີໂປຣໂມຊັ່ນ!</p>
                    <p style={{ fontSize: 14, }}>ຖ້າຕ້ອງການນຳໃຊ້ ໂປຣໂມຊັ່ນ ສາມາດເລືອກທີ່ລາຍການໄດ້ເລີຍ</p>
                </Alert>}
                <div className="d-flex justify-content-between mb-3">
                    <div />
                    <Button variant="outline-primary" onClick={() => setOnShowModal({ isOpen: true, data: null, editMode: false })}>
                        <ReactIcons.MdAdd /> ເພິ່ມ
                    </Button>
                </div>

                {(loadingPromotion && !promotionDatasLoad) ? <AnimationLoading /> : <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>ຫົວຂໍ້</th>
                            <th>ສ່ວນຫຼຸດ</th>
                            <th>ປະເພດ</th>
                            <th>ສະຖານະ</th>
                            <th>ວັນທີນຳໃຊ້</th>
                            <th style={{ textAlign: 'right' }}>ຈັດການ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {promotionDatas.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item?.name ?? "-"}</td>
                                <td>{item?.discount ?? "-"} {!item?.discountType ? "%" : "ກີບ"}</td>
                                <td>{item?.discountType ? "ເງິນເຕັມ" : "ເປີເຊັນ"}</td>
                                <td style={{ color: item?.status === "ACTIVED" ? "green" : "red" }}>{item?.status === "ACTIVED" ? "ເປີດໃຊ້" : "ປີດແລ້ວ"}</td>
                                <td>{covertTimeZone(item?.startDate) + " - " + covertTimeZone(item?.endDate)}</td>
                                <td style={{ textAlign: 'right' }}>
                                    <Button variant="outline-info" className="mr-2" onClick={() => setOnShowModal({ isOpen: true, data: item, editMode: true })}>
                                        <ReactIcons.MdEdit />
                                    </Button> &nbsp;
                                    <Button disabled={loadingUpdatePromotion} variant={item?.status === "ACTIVED" ? "success" : "outline-danger"} onClick={() => handleUpdate(item)}>
                                        {(loadingUpdatePromotion && idDeleted === item?.id) ? <Spinner size="sm" /> : <ReactIcons.FaCheck />}
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>}

                {/* <Modal show={onShowModal.isOpen} onHide={handleCloseModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{onShowModal.editMode ? "ແກ້ໄຂໂປຣໂມຊັ່ນ" : "ເພິ່ມໂປຣໂມຊັ່ນ"}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: 10 }}>
                    <FormPromotion data={onShowModal.data} editMode={onShowModal.editMode} onClose={handleCloseModal} />
                </Modal.Body>
            </Modal> */}
            </div> :
                <div style={{ padding: "5em", background: COLOR_WHITE, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <FormPromotion data={onShowModal.data} editMode={onShowModal.editMode} onClose={handleCloseModal} />
                </div>
            }
        </React.Fragment>

    );
};

export default Promotions;
